import { render, staticRenderFns } from "./minorPreference.vue?vue&type=template&id=18810e62"
import script from "./minorPreference.vue?vue&type=script&lang=js"
export * from "./minorPreference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports